import { Box, useTheme } from "@mui/material"
import { Link } from "react-router-dom"

import { Head } from "components/Head"
import { MotionDiv } from "components/motions"
import { useTranslation } from "providers/i18n"
import { TransportationCard } from "extensions/em-transportation/components/TransportationCard"

import { useTransportation } from "extensions/em-transportation/hooks/useTransportation"
import { getIcon } from "utils/icon"

export const EmTransportationPage = () => {
  const { transportationTypes } = useTransportation()
  const { t } = useTranslation()

  const theme = useTheme()
  const { styleOverrides = {} } =
    theme.components?.[`EmTransportationPage`] || {}
  const { root } = styleOverrides

  return (
    <>
      <Head title={t("Transportation")} />
      <MotionDiv
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.15 }}
      >
        <Box sx={root}>
          {transportationTypes.length > 0 &&
            transportationTypes.map(({ id, title, link, image, ...rest }) => (
              <TransportationCard
                component={Link}
                key={id}
                to={link}
                title={title}
                image={image}
                icon={getIcon(rest)}
              />
            ))}
        </Box>
      </MotionDiv>
    </>
  )
}
